// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"281":"0a0fd91e","295":"c4bba3fd","594":"ecf06ed7","621":"091c7845","824":"248d8959"}[chunkId] + ".js";
};